<!-- order center notification -->
@if(companiesCount > 0) {
@if(selectedConfig && selectedConfig.CompanyId > 0) {
<button mat-icon-button class="d-flex justify-content-center" matTooltip="{{ 'OrderCenterNotification' | translate}}"
   [matMenuTriggerFor]="profilemenu" aria-label="">
   <span class="badge-blink" [matBadge]="openOrders" [matBadgeHidden]="openOrders <= 0" matBadgeOverlap="false"
      matBadgeColor="warn">
      <i-tabler name="moped" class="icon-25 d-flex stroke-1"
         [ngClass]="isPaused ? 'text-warning' : isOpened ? 'text-green-moped' : 'text-red-moped'" />
   </span>
</button>
}
<!---->
<!---->
<!---->
<mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow p-20">
   <!---->
   <!---->
   <!---->
   <ng-scrollbar class="position-relative" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <div class="f-s-15 m-b-10">
         {{ 'Delivery' | translate}}
      </div>
      <!---->
      <!---->
      <!---->
      @if(selectedConfig && selectedConfig.DeliveryPeriods && selectedConfig.DeliveryPeriods.length > 0) {
      @for(deliveryPeriod of selectedConfig.DeliveryPeriods; track deliveryPeriod.Id) {
      <div class="d-flex justify-content-between align-items-center m-t-5">
         <span class="f-s-12">{{ deliveryPeriod.WeekdayName | translate }}</span>
         <span class="f-s-12">{{ deliveryPeriod.StartTime }} - {{ deliveryPeriod.EndTime }}</span>
      </div>
      }
      <!---->
      <!---->
      <!---->
      <button mat-flat-button type="button" color="primary" class="w-100 m-t-20" (click)="onRedirectStore()">
         <i-tabler name="clock" class="icon-20 d-flex stroke-1" />
         {{'ConfigureDeliveryHours' | translate}}
      </button>
      <!---->
      <!---->
      <!---->
      <mat-divider class="m-t-20 m-b-20" />
      <!---->
      <!---->
      <!---->
      @if(!isPaused) {
      <!---->
      <!---->
      <!---->
      <label>{{'OrderCenterNotificationStartPauseText' | translate}}</label>
      <!---->
      <!---->
      <!---->
      <div class="d-flex flex-column">
         <form [formGroup]="form">
            <mat-radio-group aria-labelledby="" class="w-100 f-s-13" formControlName="TimePause">
               @for (time of timePauseList; track time.Time) {
               <mat-radio-button class="d-flex flex-column f-s-13 m-l-0" [value]="time.Value" color="primary">{{
                  time.Name |
                  translate:
                  {time:time.Time}
                  }}</mat-radio-button>
               }
            </mat-radio-group>
         </form>
      </div>
      <!---->
      <!---->
      <!---->
      } @else {
      {{'OrderCenterNotificationOrderCenterPausedText' | translate}} <br />
      <b>{{ selectedConfig.InactivityLimitDate | date:'dd/MM HH:mm'}}</b>.
      }
      <!---->
      <!---->
      <!---->
      @if(isPauseRequestLoading) {
      <button mat-flat-button disabled type="button" color="primary" class="w-100 m-t-20">
         {{'Await' | translate}}
      </button>
      }@else {
      <button mat-stroked-button type="button" [color]="!isPaused ? 'primary' : 'accent'" class="w-100 m-t-20"
         (click)="tooglePauseStore()">
         <i-tabler [name]="isPaused ? 'player-play' : 'player-pause' " class="icon-20 d-flex stroke-1" />
         {{ (isPaused ? 'Unpause' : 'Pause') | translate }}
      </button>
      }
      }
      <!---->
      <!---->
      <!---->
   </ng-scrollbar>
   <!---->
   <!---->
   <!---->
</mat-menu>
}
